import styled from 'styled-components';
import { black } from '../../../common/colors';

export const StyledStudioTours = styled.div`
  position: relative;
  display: flex;
  flex: row;
  flex-wrap: wrap;
  width: 100%;
  background: ${black};
  line-height: 0;
`;
